module.exports = __webpack_public_path__ + "static/media/Niveau_elN5_2_1042774.0af921f4.png";